import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { ThemePalette } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FormlyFieldConfig, FormlyFormOptions, FormlyModule } from '@ngx-formly/core';
import { FeedbackPanelComponent } from '../feedback-panel/feedback-panel.component';

@Component({
	selector: 'app-modal',
	templateUrl: './modal.component.html',
	styleUrls: ['./modal.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		NgIf,
		ReactiveFormsModule,
		FeedbackPanelComponent,
		NgClass,
		MatDialogModule,
		MatButtonModule,
		NgFor,
		MatMenuModule,
		FormlyModule,
		MatIconModule,
	],
})
export class ModalComponent {
	@Input()
	title: string = this.data?.title ?? 'Are you sure?';

	@Input()
	subtitle: string = this.data?.subtitle;

	@Input()
	cancelText: string = this.data?.cancelText ?? 'Cancel';

	@Input()
	cancelColor: ThemePalette = this.data?.cancelColor ?? 'primary';

	@Input()
	showCancel = this.data?.showCancel ?? true;

	@Input()
	okText: string = this.data?.okText ?? 'OK';

	@Input()
	okColor: ThemePalette = this.data?.okColor ?? 'primary';

	@Input()
	message: string = this.data?.message;

	@Input()
	okDisabled: boolean = this.data?.okDisabled ?? false;

	@Input()
	okHidden: boolean = this.data?.okHidden ?? false;

	@Input()
	removeContentPadding: boolean = this.data?.removeContentPadding ?? false;

	@Input()
	removeContentPaddingTop: boolean = this.data?.removeContentPaddingTop ?? false;

	@Input() customButtons: { text: string; action: () => any; useMatMenu?: boolean }[] = this.data?.customButtons ?? [];
	@Input() form: UntypedFormGroup = this.data?.form;
	@Input() options: FormlyFormOptions = this.data?.options;
	@Input() fields: FormlyFieldConfig[] = this.data?.fields;
	@Input() model: any = this.data?.model;

	constructor(
		// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
		@Inject(MAT_DIALOG_DATA) public data: any,
		private readonly dialogRef: MatDialogRef<ModalComponent>
	) {}

	@Input()
	onOkClick: (args: any) => any = () => {
		if (!this.model) {
			this.dialogRef.close(true);
		} else {
			this.dialogRef.close(this.model);
		}
	};

	@Input()
	onCancelClick: (args: any) => any = () => {
		this.dialogRef.close(false);
	};

	get useButtonWithMenuItems(): boolean {
		const hasValidCustomButtons = Array.isArray(this.customButtons) && (this.customButtons as any).length > 0;
		return hasValidCustomButtons && 'useMatMenu' in (this.customButtons as any)[0] && (this.customButtons as any)[0].useMatMenu;
	}
}
